/* unplugin-vue-components disabled */import script from "./InvoicePlanModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoicePlanModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__